import styled from 'styled-components';

export const TooltipContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const TitleImage = styled.img`
  padding: 2px 2px 2px 2px;
  cursor: pointer;
`;
